import React from 'react';
import SideBarChild from '../../components/side-bar/side-child';
import Logo from '../../components/side-bar/logo';
import { UserRole, users, Clients, DashBoard, clientPortal, textBlock, admin } from './roles';
import useAuth from '../../hooks/useAuth';

const SideBar: React.FunctionComponent = (): JSX.Element => {
  const { roleType: userRole } = useAuth();

  // this is really some subset of items that are available to the user based on permissions
  let navigationItems: any = [];

  if (userRole === UserRole.admin) {
    navigationItems = [
      { name: '', child: DashBoard },
      { name: 'Clients', child: Clients },
      { name: 'Users', child: users },
      { name: 'Settings', child: textBlock },
      { name: 'Admin', child: admin },
    ];
  } else if (userRole === UserRole.client_admin) {
    navigationItems = [{ name: '', child: clientPortal }];
  } else {
  }

  return (
    <div className="bg-gray-background-dark fixed z-20 h-full w-64 text-white">
      <Logo />
      <div className="max-h-screen overflow-y-auto pb-32">
        {navigationItems.map((item: any) => {
          return (
            <div>
              <SideBarChild heading={item.name} childArray={item.child} />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default SideBar;
